<template>
  <v-row>
    <v-col>
      <v-row>
        <v-col class="text-h5 gray--text">
          Sinais Vitais
        </v-col>

        <v-col cols="auto">
          <v-btn
            color="light-blue"
            dark
            @click="showVitalMeasurementForm = true"
            :disabled="disabled"
          >
            Sinais vitais
          </v-btn>
        </v-col>
      </v-row>

      <SurgeryVitalMeasurementForm
        :showVitalMeasurementForm="showVitalMeasurementForm"
        :toggleShow="() => (showVitalMeasurementForm = !showVitalMeasurementForm)"
        :surgery="surgery"
        :surgeryMoment="surgeryMoment"
        :refreshSurgery="refreshSurgery"
        :disabled="disabled"
      />

      <v-row v-if="lodash.isEmpty(filteredVitalMeasurements)" justify="center">
        <v-col cols="6">
          <v-alert color="orange" outlined text type="info">
            Sem sinais vitais
          </v-alert>
        </v-col>
      </v-row>

      <v-row v-else>
        <v-col>
          <SurgeryVitalMeasurementListItem
            v-for="vitalMeasurement in filteredVitalMeasurements"
            :key="vitalMeasurement.id"
            :vitalMeasurement="vitalMeasurement"
            :refreshSurgery="refreshSurgery"
            :disabled="disabled"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  import SurgeryVitalMeasurementListItem from "@/components/surgery/vital_measurement/list/item.vue";
  import SurgeryVitalMeasurementForm from "@/components/surgery/vital_measurement/form.vue";

  export default {
    name: "SurgeryVitalMeasurementList",
    props: {
      surgery: Object,
      surgeryMoment: String,
      refreshSurgery: Function,
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      SurgeryVitalMeasurementListItem,
      SurgeryVitalMeasurementForm,
    },
    data() {
      return {
        showVitalMeasurementForm: false,
      };
    },
    computed: {
      vitalMeasurements() {
        return this.surgery.vitalMeasurements;
      },
      filteredVitalMeasurements() {
        let vitalMeasurements = this.lodash.filter(this.vitalMeasurements, {
          surgeryMoment: this.surgeryMoment,
        });

        return this.lodash.orderBy(vitalMeasurements, ["createdAt"], ["desc"]);
      },
    },
  };
</script>

<style lang="scss" scoped></style>
